import { UseFormSetValue } from 'react-hook-form'

type CompanyData = {
  'KodPocztowy': string[]
  'Miejscowosc': string[]
  'Nazwa': string[]
  'Nip': string[]
  'NrLokalu': string[]
  'NrNieruchomosci': string[]
  'Ulica': string[]
}

const formKeysMap = {
  'Miejscowosc': 'billing_address.city',
  'Nazwa': 'billing_address.company',
  'KodPocztowy': 'billing_address.postcode',
  'NrLokalu': 'billing_address.street[2]',
  'NrNieruchomosci': 'billing_address.street[1]',
  'Ulica': 'billing_address.street[0]',
}

export const mapCompanyData = (data: CompanyData, setValue: UseFormSetValue<any>) => {
  Object.entries(data).forEach(([key, value]) => {
    if (formKeysMap[key]) {
      setValue(formKeysMap[key], value[0])
    }
  })
  setValue('billing_address.country_code', 'PL')
}
